<template>
  <Dialog :visible="showAssessmentDialog" modal
     :style="{ width: '25rem' }" class="mx-4">
    <div class="flex flex-col items-center justify-evenly gap-5">
      <input type="datetime-local" class="border border-[var(--color-orange)]"
        v-model="formattedDate" />
      <button @click="createTask" class="bg-[var(--color-orange)] text-white rounded-xl text-lg py-3
        px-9">
        {{ $t("UserAdministrationComponent.options.createAssessment") }}
      </button>
    </div>
  </Dialog>
</template>

<script>
import NetworkAdmin from '@/helpers/networking/NetworkAdmin';
import { Dialog } from 'primevue';

export default {
  name: 'CreateAssessmentCalendarOverlayComponent',
  props: {
    data: Object,
    showAssessmentDialog: Boolean,
  },
  components: { Dialog },
  data() {
    return {
      date: new Date(),
    };
  },
  computed: {
    formattedDate: {
      get() {
        const localDate = new Date();

        const timeZoneOffset = localDate.getTimezoneOffset();

        localDate.setMinutes(localDate.getMinutes() - timeZoneOffset);

        return localDate.toISOString().slice(0, 16);
      },
      set(value) {
        this.date = value;
      },
    },
  },
  methods: {
    async createTask() {
      try {
        const postData = {
          userIDs: [...this.data.userIDs],
          schemaName: this.data?.schemaName,
          schemaID: this.data?.schemaID,
          startingTime: new Date(this.formattedDate).toUTCString(),
          forceSimilarTask: true,
        };
        await NetworkAdmin.createTask(postData);

        this.$toast.add({
          severity: 'success',
          summary: this.$t('UserAdministrationComponent.toast.successfulTaskCreation'),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        const roleDeniedHandled = await this.$store.dispatch(
          'assessmentRoleDenied/maybeShowFromApiError',
          error,
          { root: true },
        );
        if (!roleDeniedHandled) {
          this.$toast.add({
            severity: 'error',
            summary: this.$t('UserAdministrationComponent.toast.errorTaskCreation'),
            detail: '',
            life: 3000,
          });
        }
      }
      this.$emit('update:visible', false);
    },
  },
};
</script>
